import PropTypes from "prop-types";
import { breakpointSm, breakpointMd, breakpointLg } from "../Theme/theme";
var theme = {
  breakpointSm: breakpointSm,
  breakpointMd: breakpointMd,
  breakpointLg: breakpointLg
};

var Hidden = function Hidden(_ref) {
  var width = _ref.width,
      smDown = _ref.smDown,
      smUp = _ref.smUp,
      mdDown = _ref.mdDown,
      mdUp = _ref.mdUp,
      lgDown = _ref.lgDown,
      children = _ref.children;

  if (smDown) {
    return width >= theme.breakpointSm ? children : null;
  }

  if (smUp) {
    return width < theme.breakpointSm ? children : null;
  }

  if (mdDown) {
    return width >= theme.breakpointMd ? children : null;
  }

  if (mdUp) {
    return width < theme.breakpointMd ? children : null;
  }

  if (lgDown) {
    return width >= theme.breakpointLg ? children : null;
  }

  return null;
};

Hidden.propTypes = {
  /**
   * Width of the screen of the user.
   */
  width: PropTypes.number,

  /**
   * Children to be rendered.
   */
  children: PropTypes.node
};
export default Hidden;